import {
  AddressTypeAttributes,
  ApplicationsAttributes,
  BusinessPartnerContactFunctionAttributes,
  CompanyAttributes,
  CurrencyAttributes,
  DefaultKeysAttributes,
  MaterialTypeAttributes,
  SubApplicationsAttributes,
} from "@albatrosdeveloper/ave-models-package";
import { ChangeDetectorRef, Component } from "@angular/core";
import { MatSidenavModule } from "@angular/material/sidenav";
import { DefaultKeysServices } from "./defaultKeys.service";
import { DivisionService } from "app/modules/components/configuration/division/division.service.service";
import DivisionAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/division/division.entity";
import { CompanyService } from "app/modules/components/configuration/company/company.service.service";
import { MaterialTypeService } from "app/modules/components/material/material-type/material-type.service";
import { DistributionChainService } from "app/modules/components/configuration/distribution-chain/distribution-chain.service";
import DistributionChainAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/distribution-chain/distribution-chain.entity";
import { BusinessPartnerTypeService } from "app/modules/components/business-partners/business-partner-type/business-partner-type.service";
import BusinessPartnerTypeAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner-type/business-partner-type.entity";
import { RouteAreaService } from "app/modules/components/routing/route-area/route-area.service";
import RouteAreaAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/routing/route-area/route-area.entity";
import { AddressTypeService } from "app/modules/components/common/address-type/address-type.service.service";
import { BusinessPartnerContactFunctionService } from "app/modules/components/business-partners/business-partner/business-partner-contact-function-modal/business-partner-contact-function.service";
import BusinessPartnerContactAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partners-contact/business-partners-contact.entity";
import { PaymentConditionService } from "app/modules/components/master/payment-condition/payment-condition.service";
import PaymentConditionAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/masters/payment-condition/payment-condition.entity";
import { ApplicationService } from "app/modules/components/document/applications/applications.service";
import { SalesOrganizationService } from "app/modules/components/configuration/sales-organization/sales-organization.component.service";
import SalesOrganizationAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-organization/sales-organization.entity";
import { CurrencyService } from "app/modules/components/master/currency/currency.service";
import { NgSelectModule } from "@ng-select/ng-select";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  NgControl,
  NgForm,
  ReactiveFormsModule,
} from "@angular/forms";
import { CommonModule } from "@angular/common";
import { IcreateDefaultKeys } from "./interfaces/createDefaultKeys.interface";
import { MatButton, MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltip, MatTooltipModule } from "@angular/material/tooltip";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSelectModule } from "@angular/material/select";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatTabLabel } from "@angular/material/tabs";

interface IColletionsActive {
  distributionChainIds: boolean;
  company: boolean;
  materialType: boolean;
  division: boolean;
  businessPartnerTypes: boolean;
  routeArea: boolean;
  addressType: boolean;
  businessPartnerContactFunction: boolean;
  paymentCondition: boolean;
  subApplicationsIds: boolean;
  applicationsIds: boolean;
  salesOrganization: boolean;
  currency: boolean;
  businessPartnerCustomerTypes: boolean;
}

interface IColletioViewDefaultKeys {
  currentUpdate: IcreateDefaultKeys;
  title: string;
}

@Component({
  selector: "app-defaultkeys",
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavModule,
    NgSelectModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatFormFieldModule,
  ],
  templateUrl: "./defaultkeys.component.html",
  styleUrl: "./defaultkeys.component.scss",
})
export class DefaultkeysComponent {
  listDefaultKeys: DefaultKeysAttributes[] = [];
  listColletionDefaultKeys: IColletioViewDefaultKeys[] = [];

  // Datos servicios selects
  listDivisions: DivisionAttributes[];
  listCompanies: CompanyAttributes[];
  listMaterialType: MaterialTypeAttributes[];
  listDistributionChain: DistributionChainAttributes[];
  listBusinessPartnerType: BusinessPartnerTypeAttributes[];
  listRouteArea: RouteAreaAttributes[];
  listAdressType: AddressTypeAttributes[];
  listBusinessPartnerCF: BusinessPartnerContactFunctionAttributes[];
  listPaymentCondition: PaymentConditionAttributes[];
  listFilterPaymentCondition: PaymentConditionAttributes[];
  listApplication: ApplicationsAttributes[];
  listSubAplication: SubApplicationsAttributes[];
  listSalesOrganization: SalesOrganizationAttributes[];
  listCurrency: CurrencyAttributes[];

  constructor(
    private readonly defaultKeysServise: DefaultKeysServices,
    private readonly divisionService: DivisionService, //
    private readonly companyService: CompanyService, //
    private readonly materialTypeService: MaterialTypeService, //
    private readonly distributionChainService: DistributionChainService, //
    private readonly businessPartnerTypeService: BusinessPartnerTypeService, //
    private readonly routeAreaService: RouteAreaService, //
    private readonly addressTypeService: AddressTypeService, //
    private readonly businessPartnerContactFunctionService: BusinessPartnerContactFunctionService, //
    private readonly paymentConditionService: PaymentConditionService, //
    private readonly applicationService: ApplicationService, //
    private readonly salesOrganizationService: SalesOrganizationService,
    private readonly currencyService: CurrencyService,
    private snackBar: MatSnackBar,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.fetchAllDefaultKeys();
    this.fetchAllDivision();
    this.fetchAllCompany();
    this.fetchAllMaterialType();
    this.fetchAllDistributionChain();
    this.fetchAllBusinessParnertTYype();
    this.fetchAllRoute();
    this.fetchAllAdressType();
    this.fetchAllbusinessPartnerContactFunction();
    this.fetchAllPaymentCondition();
    this.fetchAllApplicationService();
    this.fetchAllSalesOrganizationService();
    this.fetchAllCurrencyService();
  }

  updatedCurrentDefaultKeys(data, dataActive): FormGroup {
    return this.fb.group({
      distributionChainIds: new FormControl({
        value: data.distributionChainIds ?? null,
        disabled: !this.isServiceActive("distributionChainIds", dataActive),
      }),
      company: new FormControl({
        value: data.company ?? null,
        disabled: !this.isServiceActive("company", dataActive),
      }),
      materialType: new FormControl({
        value: data.materialType ?? null,
        disabled: !this.isServiceActive("materialType", dataActive),
      }),
      division: new FormControl({
        value: data.division ?? null,
        disabled: !this.isServiceActive("division", dataActive),
      }),
      businessPartnerTypes: new FormControl({
        value: data.businessPartnerTypes ?? null,
        disabled: !this.isServiceActive("businessPartnerTypes", dataActive),
      }),
      routeArea: new FormControl({
        value: data.routeArea ?? null,
        disabled: !this.isServiceActive("routeArea", dataActive),
      }),
      addressType: new FormControl({
        value: data.addressType ?? null,
        disabled: !this.isServiceActive("addressType", dataActive),
      }),
      businessPartnerContactFunction: new FormControl({
        value: data.businessPartnerContactFunction ?? null,
        disabled: !this.isServiceActive(
          "businessPartnerContactFunction",
          dataActive
        ),
      }),
      paymentCondition: new FormControl({
        value: data.paymentCondition ?? null,
        disabled: !this.isServiceActive("paymentCondition", dataActive),
      }),
      subApplicationsIds: new FormControl({
        value: data.subApplicationsIds ?? null,
        disabled: !this.isServiceActive("subApplicationsIds", dataActive),
      }),
      applicationsIds: new FormControl({
        value: data.applicationsIds ?? null,
        disabled: !this.isServiceActive("applicationsIds", dataActive),
      }),
      salesOrganization: new FormControl({
        value: data.salesOrganization ?? null,
        disabled: !this.isServiceActive("salesOrganization", dataActive),
      }),
      currency: new FormControl({
        value: data.currency ?? null,
        disabled: !this.isServiceActive("currency", dataActive),
      }),
      businessPartnerCustomerTypes: new FormControl({
        value: data.businessPartnerCustomerTypes ?? null,
        disabled: !this.isServiceActive(
          "businessPartnerCustomerTypes",
          dataActive
        ),
      }),
    });
  }

  private isServiceActive(service: string, services: string[]) {
    return services?.filter((item) => service === item).length > 0
      ? true
      : false;
  }

  private transformeData(data) {
    return data.map((item) => {
      return {
        currentUpdate: this.updatedCurrentDefaultKeys(
          item.fields,
          item.fieldsToUse
        ),
        title: item.collectionDescription,
        _id: item._id,
      };
    });
  }

  filterOptions(event: any) {
    const searchTerm = event.target.value.toLowerCase();

    this.listFilterPaymentCondition = this.listPaymentCondition.filter(
      (option) => option.name.toLowerCase().includes(searchTerm)
    );
  }

  onDropdownOpened(opened: boolean) {
    if (opened) {
      this.listFilterPaymentCondition = [...this.listPaymentCondition]; // Restablece las opciones
    }
  }

  onHandleSave(data: FormControl, id: string) {
    this.fetchUpdateDefaulKey(data.value, id);
  }
  private fetchAllDefaultKeys() {
    this.defaultKeysServise.withCountDefaultKeys().subscribe({
      next: (res) => {
        this.listDefaultKeys = res.data[0].data;

        this.listColletionDefaultKeys = this.transformeData(
          this.listDefaultKeys
        );
      },
      error: (error) => {
        this.snackBar.open(error.error.message || "Error al obtener llaves por defecto.","Cerrar",{ duration: 5000});
      },
    });
  }

  private fetchAllDivision() {
    this.divisionService.findToComboBox().subscribe({
      next: (res) => {
        this.listDivisions = res.data;
      },
    });
  }

  private fetchAllCompany() {
    this.companyService.findToComboBox().subscribe({
      next: (res) => {
        this.listCompanies = res.data;
      },
    });
  }

  private fetchAllMaterialType() {
    this.materialTypeService.findToComboBox().subscribe({
      next: (res) => {
        this.listMaterialType = res.data;
      },
    });
  }

  private fetchAllDistributionChain() {
    this.distributionChainService.findToComboBox().subscribe({
      next: (res) => {
        this.listDistributionChain = res.data;
      },
    });
  }

  private fetchAllBusinessParnertTYype() {
    this.businessPartnerTypeService.findToComboBox().subscribe({
      next: (res) => {
        this.listBusinessPartnerType = res.data;
      },
    });
  }

  private fetchAllRoute() {
    this.routeAreaService.findToComboBox().subscribe({
      next: (res) => {
        this.listRouteArea = res.data;
      },
    });
  }

  private fetchAllAdressType() {
    this.addressTypeService.findToComboBox().subscribe({
      next: (res) => {
        this.listAdressType = res.data;
      },
    });
  }

  private fetchAllbusinessPartnerContactFunction() {
    this.businessPartnerContactFunctionService.findToComboBox().subscribe({
      next: (res) => {
        this.listBusinessPartnerCF = res.data;
      },
    });
  }

  private fetchAllPaymentCondition() {
    this.paymentConditionService.findToComboBox().subscribe({
      next: (res) => {
        this.listFilterPaymentCondition = res.data;
        this.listPaymentCondition = res.data;
      },
    });
  }
  private fetchAllApplicationService() {
    this.applicationService.findToComboBox().subscribe({
      next: (res: any) => {
        this.listApplication = res;

        // agregar Sub aplicaciones
        const dataSubAplicationes = [];
        this.listApplication?.forEach((item) =>
          dataSubAplicationes.push(...item.subApplications)
        );

        this.listSubAplication = dataSubAplicationes;
      },
    });
  }

  private fetchAllSalesOrganizationService() {
    this.salesOrganizationService.findToComboBox().subscribe({
      next: (res) => {
        this.listSalesOrganization = res.data;
      },
    });
  }

  private fetchAllCurrencyService() {
    this.currencyService.findToComboBox().subscribe({
      next: (res) => {
        this.listCurrency = res.data;
      },
    });
  }

  private fetchUpdateDefaulKey(data: IcreateDefaultKeys, id: string) {
    this.defaultKeysServise.updateDefaultKeys(data, id).subscribe({
      next: (res) => {
        if (res.statusCode === "200") {
          this.snackBar.open("Default Keys editado exitosamente", "Cerrar", {
            duration: 3000,
          });
        }
      },
      error: (error) => {
        this.snackBar.open(error.error.message || "Error al editar keys.","Cerrar",{ duration: 5000});
      },
    });
  }
}
